$(document).on('turbolinks:load', function() {
    $('.modal').on('show.bs.modal', function (event) {
        const $modal = $(this);
        const target = $(event.relatedTarget);
        $modal.find('button[data-url]').attr('data-url', target.data('url'));
    });
});
